export default __webpack_public_path__ + "static/media/blur.cdcf9466.png";